import { EClickPosition } from 'shared/constant';
import { active } from '~/utils/active/active';
import { SHARING_DEFAULT_PID } from '~/utils/active';

export const activeToFeed = (clickPosition: EClickPosition, clickId?: string): void => {
  active({
    schemaOption: {
      pid: SHARING_DEFAULT_PID,
      pageType: 'feed',
      categoryId: 0,
    },
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};
